import type { FaireProductEntity } from "../../entity_types/product";

export const p_aseh54ahvy: FaireProductEntity = {
  token: "p_aseh54ahvy",
  type: "product",
  name: "KETO PEANUT SAUCE- VEGAN, No Sugar, Natural, Gluten Free,",
  brandToken: "b_gvacf54e28",
  brandName: "Wynn's Kitchen",
  imageUrl:
    "https://cdn.faire.com/fastly/bcf48969837ca41b79388e26c79ba21871e815555a11384f37ddc37623220f1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4db581958fb7396bf59fd31af1447f1245ea037cd34829d8327d62a94df3eccb.jpeg",
    "https://cdn.faire.com/fastly/78c7661345892289cd1d6cb621f5eca7abd9a573434ce2fc3063eb0892bfc4c9.jpeg",
    "https://cdn.faire.com/fastly/ba89c075ae8f18896505380503b549ae321d3754ab8c5a680e95342045a3233c.jpeg",
    "https://cdn.faire.com/fastly/d4a70dc178137b2e9418c6ed7db0ec20a71b6bdab0f4114f85b989fdfa8c00eb.jpeg",
    "https://cdn.faire.com/fastly/72883c534d7a191b2eb13a8f3d59b130f786fbff5643064f5f4257b313e41715.jpeg",
    "https://cdn.faire.com/fastly/be28b0fd43cdbe78edbfba1911033259f9700c74f7e9ba359dd6f6fc5d68ed34.jpeg",
    "https://cdn.faire.com/fastly/bb16c70b3a75042cba2909134c2fd569827ca4d20d2988ffb3e22142510d9596.png",
    "https://cdn.faire.com/fastly/5cc48b2f7f14d08e26e70f375da8b8fb6dd6318934025d8e24c3d87524ba213a.jpeg",
    "https://cdn.faire.com/fastly/3f264f906d207c5516437509c3c58d35f908c525ded58b3602bcc13ece6f8609.jpeg",
    "https://cdn.faire.com/fastly/a925542639937b2f26bf5a82b8faf1368e1f8bba1a729c76ba9925b39ce333ea.jpeg",
  ],
  priceDollars: 7.2,
  description:
    "• Natural ingredients - vegan, no added sugar - gluten free - no soy - keto friendly - non-GMO verified\n\nWynn's Kitchen peanut sauce is your next guiltless addiction. It's smooth, sweet creaminess will have you eating it by the spoonful. It is sweet without sugar, savory from ginger and garlic, and citrusy from fresh limes. Perfectly drizzable and dippable, you can use it as a dressing, dipping sauce or spread it on your favorite protein. This sweet and savory peanut sauce will leave you craving for more.\n\n• No sugar added - gluten free - non-GMO verified\n• All natural ingredients - keto & paleo friendly",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:12.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
